import { type FC, memo } from 'react';
import { Icon } from '@/components/elements/Icon';
import { PlayerButton } from './Button';

const SkipRewindButton: FC<SkipRewindButtonProps> = ({ type, handleClick }) => (
  <PlayerButton
    label={type === 'skip' ? '+10 seconds' : '-10 segundos'}
    onClick={handleClick}
  >
    <Icon
      iconName={type === 'skip' ? 'SkipStepForward' : 'SkipStepBack'}
      color="white"
    />
  </PlayerButton>
);

export default memo(SkipRewindButton);

type SkipRewindButtonProps = {
  type: 'skip' | 'rewind';
  handleClick: () => void;
};
